var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-md-12\">\n<pkp-tiles see-all-link=\"true\"></pkp-tiles>\n</div>\n<div class=\"col-sm-12\" ng-if=\"dashboard.isSnamBidCollectorEnabled\">\n<a class=\"btn btn-primary\" href=\"{{dashboard.snamBiddingUrl}}\">Gela and Mazara (SNAM) Auctions</a>\n</div>\n";
var id1="app/dashboard/current-auctions.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;